import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-colter',
  templateUrl: './lieux-colter.component.html',
  styleUrls: ['./lieux-colter.component.css']
})
export class LieuxColterComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxColter: Subscription;
  private valeurTableauA4h_1: number[] = [];
  private valeurTableauA4h_2: number[] = [];
  private valeurTableauA4h_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxColter) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxColter', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
      for (let index = 0; index < this.lieuxColter.length; index++) {
        this.ajoutValidateurCroiseLieuxColter(index);
        this.lieuxColter.controls[index].updateValueAndValidity();
      }

      // Tri apres rechargement questionnaire
      this.trierLieuxColter();
    
      // Calcul des totaux lieux Colter
      this.subLieuxColter = this.lieuxColter.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4h_1 = [];
            this.valeurTableauA4h_2 = [];
            this.valeurTableauA4h_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4h
              this.calculAutoTotauxA4h(index, this.valeurTableauA4h_1, 'aaLieuColterNbPerm', 'aaLieuColterNbPermTot');      
              this.calculAutoTotauxA4h(index, this.valeurTableauA4h_2, 'aaLieuColterNbPermEtp', 'aaLieuColterNbPermEtpTot');      
              this.calculAutoTotauxA4h(index, this.valeurTableauA4h_3, 'aaLieuColterNbVict', 'aaLieuColterNbVictTot');      
            });
          }
        });
      this.lieuxColter.updateValueAndValidity();
    }, 1000);
   
  }

  ngOnDestroy(): void {
    if (this.subLieuxColter) {
      this.subLieuxColter.unsubscribe();
    }
  }

  get lieuxColter() {
    return this.rootForm.get('moyens').get('lieuxColter') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxColter() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuColterNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxColter.push(new UntypedFormGroup({
      aaLieuColterRang: new UntypedFormControl(this.lieuxColter.length, Validators.required),
      aaLieuColterCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuColterCodCom')),
      aaLieuColterQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuColterQp')),
      aaLieuColterNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuColterNbPerm')),
      aaLieuColterNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuColterNbPermEtp')),
      aaLieuColterNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuColterNbVict'))
    }));
    this.step = this.lieuxColter.length - 1 ;
    this.ajoutValidateurCroiseLieuxColter(this.lieuxColter.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuColterNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxColter (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxColter.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA74Colter,
      this.validationService.ctrlA75Colter
    ]);
  }

  public supprimerLieuxColter(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxColter.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuColterCodCom']} ?`)) {
        this.lieuxColter.removeAt(index);
      }
    } else {
      this.lieuxColter.removeAt(this.lieuxColter.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuColterNb').setValue(this.lieuxColter.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxColter(): void {
    this.lieuxColter.controls.sort((a, b) => {
      if (a.get('aaLieuColterRang').value < b.get('aaLieuColterRang').value) {
            return -1;
      } else if (a.get('aaLieuColterRang').value > b.get('aaLieuColterRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxColter.length; index++) {
      this.lieuxColter.controls[index].get('aaLieuColterRang').setValue(index);
    }
    this.trierLieuxColter();
  }

  private calculAutoTotauxA4h(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxColter.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
}

}
